import authenticationControl from './authenticationControl.js';
$('#sendForgotPasswordForm').click(function () {
    authenticationControl.sendSecretKey();
});

authenticationControl.initForgotPasswordPage();